



































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';

import { fetchNDV } from './fetchNDV';
import { DataApi } from './models/NDVBase.model';
import {
  TableParam,
  CurrentId,
  DataApi as Api,
} from './models/NDVModalTabs.model';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import TabNDV from './TabsModals/TabNDV.vue';
import TabProducts from './TabsModals/Products/TabProducts.vue';
import TabReservations from './TabsModals/Reservations/TabReservations.vue';
import TabAttentions from './TabsModals/TabAttentions.vue';

@Component({
  components: {
    GridComponent: AgGridVue,
    TabNDV,
    TabProducts,
    TabReservations,
    TabAttentions,
  },
})
export default class NDVModalTabs extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ required: true, default: {} }) data!: DataApi;

  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  columnApi: any = null;

  loading: boolean = false;

  step: string = 'ndv';
  dialog: boolean = true;

  currentId: CurrentId = {
    products: null,
    reservations: null,
    attentions: null,
  };

  dataApi: Api = {
    products: [],
    reservations: [],
    attentions: [],
  };
  localData: DataApi = {};
  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  constructor() {
    super();
    //console.log('data   ', this.data);
    this.localData = this.data;
    this.gridOptions = {
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  handleMainGridReady(event: GridReadyEvent): void {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData([{}]);
  }

  handleClosed(): void {
    this.localData = {};
    Object.keys(this.currentId).forEach(
      key => (this.currentId[key as keyof CurrentId] = null)
    );
    this.$emit('cerrar');
  }

  @Watch('step')
  async validateValue() {
    if (
      this.step === 'products' &&
      this.currentId.products !== this.localData.ndvnumero
    ) {
      this.dataApi.products = await this.getTab({ table: 'get_products' });
      this.currentId.products = this.localData.ndvnumero;
    } else if (
      this.step === 'reservations' &&
      this.currentId.reservations !== this.localData.ndvnumero
    ) {
      this.dataApi.reservations = await this.getTab({
        table: 'get_reservations',
      });
      this.currentId.reservations = this.localData.ndvnumero;
    } else if (
      this.step === 'attentions' &&
      this.currentId.attentions !== this.localData.ndvnumero
    ) {
      this.dataApi.attentions = await this.getTab({ table: 'get_attentions' });
      this.currentId.attentions = this.localData.ndvnumero;
    }
  }

  async getTab({ table }: TableParam): Promise<any> {
    const self = this;
    this.loading = true;
    self.loadingService.showLoading();
    return await fetchNDV({
      endpoint: table,
      body: { ndvnumero: this.localData.ndvnumero },
    })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;
        if (CODIGO_RESPUESTA != '1' || MENSAJE_RESPUESTA === 'SIN DATA') {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
        return LISTA;
      })
      .catch((error: Error) => {
        //console.error(error.message);
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
        throw error;
      })
      .finally(() => {
        this.loading = false;
        self.loadingService.hideLoading();
      });
  }
}
